import { Enum } from "./Enum";

export const EPlaces = Object.freeze({
  MAIN: "/place",
  CATEGORY: "place/category",
  IMPORT: "/import-data/place",
  BY_ID: (id: string) => `place/${id}`,
});

export type EPlaces = Enum<typeof EPlaces>;
